export type PresetIncludes = {
  messages: boolean;
  keywords: boolean;
  optOut: boolean;
  audience: boolean;
};

export const DEFAULT_PRESET_INCLUDES: PresetIncludes = {
  messages: true,
  keywords: true,
  optOut: true,
  audience: false,
};
